"use client"

import { motion } from "framer-motion"

export function StatsSection() {
  return (
    <section className="py-20 px-6 bg-secondary">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="border-2 border-dashed border-border rounded-3xl p-8 text-center bg-background"
          >
            <div className="mb-4">
              <span className="font-serif text-7xl md:text-8xl font-bold">500</span>
              <span className="text-accent text-5xl md:text-6xl font-serif font-bold">+</span>
            </div>
            <h3 className="font-serif text-2xl font-semibold mb-4">Брендов автоматизировали Instagram</h3>
            <p className="text-muted-foreground font-sans leading-relaxed">
              Более 500 брендов уже экономят 20+ часов в неделю с InstaSell
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="border-2 border-dashed border-border rounded-3xl p-8 text-center bg-background"
          >
            <div className="mb-4">
              <span className="font-serif text-7xl md:text-8xl font-bold">2.5</span>
              <span className="text-accent text-5xl md:text-6xl font-serif font-bold">M+</span>
            </div>
            <h3 className="font-serif text-2xl font-semibold mb-4">Сообщений обработано</h3>
            <p className="text-muted-foreground font-sans leading-relaxed">
              За последний месяц InstaSell автоматически ответил на 2.5 миллиона сообщений
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="border-2 border-dashed border-border rounded-3xl p-8 text-center bg-background"
          >
            <div className="mb-4">
              <span className="font-serif text-7xl md:text-8xl font-bold">90</span>
              <span className="text-accent text-5xl md:text-6xl font-serif font-bold">сек</span>
            </div>
            <h3 className="font-serif text-2xl font-semibold mb-4">Среднее время ответа</h3>
            <p className="text-muted-foreground font-sans leading-relaxed">
              Ваши клиенты получают ответы за 90 секунд вместо 4 часов
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
